exports = module.exports = require("../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".default-tabs.el-menu.el-menu--horizontal{margin-bottom:14px;height:40px;border-bottom:solid 2px #e6e6e6}.default-tabs.el-menu.el-menu--horizontal .el-menu-item{height:40px;line-height:40px;font-weight:500;color:#303133;border-bottom:solid 2px #e6e6e6 !important;padding:0 !important;margin:0 20px !important}.default-tabs.el-menu.el-menu--horizontal .el-menu-item:first-child{margin-left:0 !important}.default-tabs.el-menu.el-menu--horizontal .el-menu-item:hover{border-bottom:solid 2px #e6e6e6 !important}.default-tabs.el-menu.el-menu--horizontal>.el-menu-item.is-active{color:#1890ff;border-bottom:2px solid #1890ff !important}\n", ""]);

// exports
